const sourceCode:any = [
  {
      type:"order",
      value: "DH"
  },
  {
      type:"designation",
      value: "CDDV"
  },
  {
      type:"stockimport",
      value: "NH"
  },
]
export const getLinkBySourceCode = (fullCode?:any)=>{
  const id = Number(fullCode.replace(/\D/g, ""));
  const code = fullCode.replace(/[^a-z]/gi, '');
  const result = sourceCode?.filter((item:any)=>{
    return item?.value === code
  })
  return `/${result && result[0]?.type}/${id}/view`
}